import React, { useEffect, useState } from "react";
import styles from "./Banks.module.scss";
// import { BankDetails } from "../../constants/bankDetails";
import { apiClient } from "../../hooks/apiClient";
import {
  // openLoader,
  closeLoader,
  openLoader,
} from "../../redux/actions/loader/loaderActions";
import { useDispatch } from "react-redux";
import {
  // ToastSuccessStyles,
  ToastErrorStyles,
} from "../../constants/toastStyles";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import Button from "../button/Button";
import {
  TrackOrderStatusAction,
  closeWin,
  openWin,
  payOrderAction,
} from "../../redux/actions/orderStatus/orderStatusAction";

type BankProps = {
  reference: string;
};
const Banks = ({ reference }: BankProps) => {
  const dispatch = useDispatch();
  const [banks, setBanks] = useState<any>();
  const fetchBanks = async () => {
    try {
      const data: any = await apiClient.get("/checkout/banks");
      dispatch(closeLoader());
      setBanks(data?.data?.data);
    } catch (error: any) {
      dispatch(closeLoader());
      const message =
        error?.response?.data?.Message || error?.response?.data?.message;
      dispatch(
        openToastAndSetContent({
          toastStyles: ToastErrorStyles,
          toastContent: message,
        })
      );
    }
  };

  // useEffect(() => {
  //   fetchBanks();
  // });
  const updatePendingStatus = (__window: Window | null) => {
    console.log("Close update");
    closeWin(__window);
  };
  const handleSubmit = () => {
    const payload = {
      reference: reference,
      paymentOption: "BA",
      bankAccount: {
        bankCode: "0017",
      },
    };
    payOrderAction(payload, dispatch, (data: any) => {
      console.log(data);
      const __window = openWin(data.data.paymentDetail.redirectUrl);
      console.log("Opened a window");
      setTimeout(() => {
        TrackOrderStatusAction(
          payload,
          dispatch,
          updatePendingStatus,
          __window
        );
      }, 1000);
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.choose}>
        <p className={styles.instruction}>
          You will be redirected to bank page to complete the payment
        </p>
        <Button
          value="Click to proceed"
          onClick={handleSubmit}
          className={styles.buttonActive}
        />
      </div>
    </div>
  );
};

export default Banks;
